import axios from '@axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: () => ({
    list: null,
    enrolments: {},
    invoices: {},
    calendar: null,
  }),
  mutations: {
    setCertificationList(state, payload) {
      state.list = payload
    },

    setCertificationEnrolments(state, payload) {
      Vue.set(state.enrolments, payload.id, payload.data)
    },

    setCertificationInvoices(state, payload) {
      Vue.set(state.invoices, payload.id, payload.data)
    },

    updateEnrolment(state, payload) {
      const list = state.enrolments[payload.params.certificationId]
      if (!list || !list['hydra:member']) return

      const index = list['hydra:member'].findIndex(enrolment => enrolment.id === payload.params.id)
      if (index !== -1) Vue.set(list['hydra:member'], index, payload.data)
    },

    setCalendar(state, payload) {
      state.calendar = payload
    },
  },
  actions: {
    fetchList(store, params) {
      const request = axios.get('certifications', params)
      request.then(response => {
        if (response && response.status === 200) {
          store.commit('setCertificationList', response.data)
        }
      })
      return request
    },

    addCertification(store, params) {
      return axios.post('certifications', params)
    },

    editCertification(store, params) {
      return axios.put(`certifications/${params.id}`, params.payload)
    },

    deleteCertification(store, params) {
      return axios.delete(`certifications/${params.id}`)
    },

    fetchCertification(store, params) {
      return axios.get(`certifications/${params.id}`)
    },

    fetchEnrolmentsForCertification(store, id) {
      const request = axios.get('certification_enrolments', { params: { 'slot.certification': id } })
      request.then(response => {
        if (response && response.status === 200) {
          store.commit('setCertificationEnrolments', { id, data: response.data })
        }
      })
      return request
    },

    fetchInvoicesForCertification(store, id) {
      const request = axios.get('invoices', { params: { 'certificationEnrolments.slot.certification': id } })
      request.then(response => {
        if (response && response.status === 200) {
          store.commit('setCertificationInvoices', { id, data: response.data })
        }
      })
      return request
    },

    addEnrolment(store, params) {
      return axios.post('certification_enrolments', {
        slot: params.slot,
        user: params.user,
      })
    },

    deleteEnrolment(store, params) {
      return axios.delete(`certification_enrolments/${params.id}`)
    },

    setAttendance(store, params) {
      const body = {
        attendance: params.attendance,
        passed: params.passed,
        justification: params.justification,
      }
      if (params.removeResultFile) {
        body.removeResultFile = true
      }
      if (params.resultFile) {
        body.resultFile = params.resultFile
      }

      return axios.put(`certification_enrolments/${params.id}/edit_attendance`, body).then(response => {
        if (response && response.status === 200) {
          store.commit('updateEnrolment', { params, data: response.data })
        }
      })
    },

    fetchCalendar(store, params) {
      return axios.get('certifications/calendar', params).then(response => {
        if (response && response.status === 200) {
          store.commit('setCalendar', response.data)
        }
      })
    },

    /** Opcje zapisu na certyfikację (widok menedżera, pkt 7). */
    fetchEnrolmentOptions(store, { userId, date }) {
      return axios.get(`users/${userId}/certification_enrolment_options`, {
        params: date ? { date } : {},
      })
    },

    downloadCertificate(store, params) {
      return axios.get(`certification_enrolments/${params.id}/certificate`, {
        responseType: 'blob',
      })
    },

    downloadResultFile(store, params) {
      // Cache-bust by media object id: same enrolment URL must not reuse a prior blob
      // after the result file is replaced. Do not send Cache-Control/Pragma request
      // headers — they are not in CORS allow_headers and break the preflight.
      const requestConfig = {
        responseType: 'blob',
      }
      if (params.mediaObjectId != null) {
        requestConfig.params = { v: params.mediaObjectId }
      }

      return axios.get(`certification_enrolments/${params.id}/result_file`, requestConfig)
    },
  },
}
